export default class UploadList {

    constructor(container) {
        this.container = container;
        this.list = this.container.find('tbody');
        this.inProgress = {};
        this.visibility = false;
    }

    updateVisibility() {
        const keys = Object.keys(this.inProgress);

        if(!this.visibility && keys.length) {
            this.container.removeClass('hide');
            this.visibility = true;
            return;
        }
        if(this.visibility && !keys.length) {
            this.container.addClass('hide');
            this.visibility = false;
        }
    }

    addFile(key, file) {
        this.inProgress[key] = {file};
        this.addToUI(key);
        this.updateVisibility();
    }

    removeFile(key) {
        this.removeFromUI(key);
        delete this.inProgress[key];
        this.updateVisibility();
    }

    addToUI(key) {
        const file = this.inProgress[key].file;
        const html = $('<tr>')
            .attr('id', 'inProgress-' + key)
            .append(
                $('<td>').text(file.name)
            )
            .append(this.generateProgressBar());

        this.inProgress[key].html = html;
        this.list.append(html);
    }

    removeFromUI(key) {
        this.inProgress[key].html.remove();
    }

    updateProgress(key, percent) {
        this.inProgress[key].html
            .find('.determinate')
            .css('width', percent + '%');
    }

    generateProgressBar() {
        const determinate = $('<div>')
            .addClass('determinate')
            .css('width', 0);

        const progress = $('<div>')
            .addClass('progress')
            .append(determinate);

        return $('<td>')
            .addClass('full-width')
            .append(progress);
    }

}